import { GET_RAN_FIBERSITE_DATA } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const fetchFiberSiteData = async () => {
  try {
    const resp = await apiClient.get(GET_RAN_FIBERSITE_DATA, {});
    return resp.data;
  } catch (error) {
    handleApiError(error);
  }
};
